/*
 * @Author: your name
 * @Date: 2022-04-19 00:56:33
 * @LastEditTime: 2022-04-19 01:02:03
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \rcd-wap\src\filters\time-filter.ts
 */
import Vue from 'vue'
import ConvertService  from "../utils/convert-service"

//截取时间，得到年月日格式
Vue.filter('ToString', (dateStr, pattern = '', separator = '/')=> {
    return ConvertService.ToString(dateStr, pattern, separator)
})